import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { productConstant } from "../constants/constants";


class ProductStore extends EventEmitter {
    constructor() {
        super();
        this.products = [];
    }

    getAll() {
        return this.products;
    }

    handleAction(action) {
        switch (action.type) {
            case productConstant.PRODUCT_CREATED: {
                const { product } = action;
                this.products.push(product);
                this.emit(productConstant.PRODUCT_CREATED, `product ${product.productName} created successfully.`);
                this.emit(productConstant.PRODUCTS_STORE_CHANGE);
                break;
            }
            case productConstant.PRODUCT_CREATION_FAILED: {
                this.emit(productConstant.PRODUCT_CREATION_FAILED, action.msg);
                break;
            }
            case productConstant.FETCHED_ALL_PRODUCTS: {
                this.products = action.data;
                this.emit(productConstant.PRODUCTS_STORE_CHANGE);
                break;
            }
            case productConstant.PRODUCTS_FETCH_FAILED: {
                this.emit(productConstant.PRODUCTS_FETCH_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}



const productStore = new ProductStore();
dispatcher.register(productStore.handleAction.bind(productStore));
//window.productStore = productStore;
//window.dispatcher = dispatcher;
export default productStore;


// WEBPACK FOOTER //
// ./src/jsx/store/product-store.jsx